import { styled } from '@mui/material/styles';

export const TabsContainer = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(8),

  '.MuiTabs-root': {
    margin: theme.spacing(8, 0),
  },

  'div[role="tabpanel"]': {
    '> div': {
      padding: 0,
    },
  },
}));
